import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import HttpStatus from '../../utility/status.enum';

const {
  invitePaypalBegin,
  invitePaypalSuccess,
  invitePaypalErr,
  disconnectPaypalBegin,
  disconnectPaypalSuccess,
  disconnectPaypalErr,
  getPaypalCardsBegin,
  getPaypalCardsSuccess,
  getPaypalCardsErr,
  getPaypalSetupTokenBegin,
  getPaypalSetupTokenSuccess,
  getPaypalSetupTokenErr,
  exchangePaypalTokenBegin,
  exchangePaypalTokenSuccess,
  exchangePaypalTokenErr,
  deletePaypalCardBegin,
  deletePaypalCardSuccess,
  deletePaypalCardErr,
  setDefaultPaypalCardBegin,
  setDefaultPaypalCardSuccess,
  setDefaultPaypalCardErr,
} = actions;

const invitePaypalAPIName = '/admin/paypal-invitation';
const disconnectPaypalAPIName = '/admin/paypal-disconnect';
const getPaypalCardsAPIName = '/admin/get-paypal-cards';
const getPaypalSetupTokenAPIName = '/admin/get-paypal-setup-token';
const exchangePaypalTokenAPIName = '/admin/exchange-paypal-token';
const deletePaypalCardAPIName = '/admin/delete-paypal-card';
const setDefaultPaypalCardAPIName = '/admin/set-default-paypal-card';

const paypalInvitation = (values) => {
  return async (dispatch) => {
    dispatch(invitePaypalBegin());
    try {
      const response = await DataService.post(invitePaypalAPIName, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(invitePaypalErr(response?.data?.message));
      } else {
        dispatch(invitePaypalSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(invitePaypalErr(err));
    }
  };
};

const paypalDisconnect = (values) => {
  return async (dispatch) => {
    dispatch(disconnectPaypalBegin());
    try {
      const response = await DataService.post(disconnectPaypalAPIName, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(disconnectPaypalErr(response?.data?.message));
      } else {
        dispatch(disconnectPaypalSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(disconnectPaypalErr(err));
    }
  };
};

const getPaypalCards = (values) => {
  return async (dispatch) => {
    dispatch(getPaypalCardsBegin());
    try {
      const response = await DataService.post(getPaypalCardsAPIName, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(getPaypalCardsErr(response?.data?.message));
      } else {
        dispatch(getPaypalCardsSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(getPaypalCardsErr(err));
    }
  };
};

const getPaypalSetupToken = (values) => {
  return async (dispatch) => {
    dispatch(getPaypalSetupTokenBegin());
    try {
      const response = await DataService.post(getPaypalSetupTokenAPIName, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(getPaypalSetupTokenErr(response?.data?.message));
      } else {
        dispatch(getPaypalSetupTokenSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(getPaypalSetupTokenErr(err));
    }
  };
};

const exchangePaypalToken = (values) => {
  return async (dispatch) => {
    dispatch(exchangePaypalTokenBegin());
    try {
      const response = await DataService.post(exchangePaypalTokenAPIName, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(exchangePaypalTokenErr(response?.data?.message));
      } else {
        dispatch(exchangePaypalTokenSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(exchangePaypalTokenErr(err));
    }
  };
};

const deletePaypalCard = (values) => {
  return async (dispatch) => {
    dispatch(deletePaypalCardBegin());
    try {
      const response = await DataService.post(deletePaypalCardAPIName, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(deletePaypalCardErr(response?.data?.message));
      } else {
        dispatch(deletePaypalCardSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(deletePaypalCardErr(err));
    }
  };
};

const setDefaultPaypalCard = (values) => {
  return async (dispatch) => {
    dispatch(setDefaultPaypalCardBegin());
    try {
      const response = await DataService.post(setDefaultPaypalCardAPIName, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(setDefaultPaypalCardErr(response?.data?.message));
      } else {
        dispatch(setDefaultPaypalCardSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(setDefaultPaypalCardErr(err));
    }
  };
};

export {
  paypalInvitation,
  paypalDisconnect,
  getPaypalCards,
  getPaypalSetupToken,
  exchangePaypalToken,
  deletePaypalCard,
  setDefaultPaypalCard,
};
